<template>
  <el-menu
    :default-active="defaultActive"
    :default-openeds="['applet']"
    class="my-el-menu-no-border"
    @select="routerSelect"
    background-color="#545C64"
    text-color="#FFFFFF"
    active-text-color="#FFD04B">
    <el-submenu index="applet">
      <span slot="title">小程序管理</span>
      <el-menu-item index="owned">
        <span slot="title">已有小程序</span>
      </el-menu-item>
      <el-menu-item index="check">
        <span class="check" slot="title">
          用户提交审核<span v-if="notCheckCount > 0" class="dot">{{ notCheckCount }}</span>
        </span>
      </el-menu-item>
    </el-submenu>
    <el-menu-item index="topics">
      <span slot="title">专题管理</span>
    </el-menu-item>
    <el-menu-item index="swiper">
      <span slot="title">轮播图管理</span>
    </el-menu-item>
  </el-menu>
</template>
<script>
import * as api from '~/api'
export default {
  data () {
    return {
      // 未审核数量
      notCheckCount: 0,
      // 小程序管理中的已有小程序需要高亮的路径
      appletOwnedPathList: ['/index/applet/owned', '/index/applet/add'],
      // 小程序管理中的已有小程序中添加小程序 因为后面带着id 通过字符串包含来判断
      appletOwnedAddPath: '/index/applet/update',
      // 用户提交审核的小程序列表
      appletCheckPathList: ['/index/applet/check'],
      // 审核的小程序详情
      appletCheckDetailsPath: '/index/applet/checkDetails',
      // 专题管理需要高亮的路径
      topicsPathList: ['/index/topics/list', '/index/topics/add'],
      // 添加专题
      topicsAddPath: '/index/topics/update',
      // 轮播图管理
      swiperPathList: ['/index/swiper']
    }
  },
  created () {
    this.getNotCheckCount()
  },
  computed: {
    // 当前页面路径
    currentPagePath () {
      return this.$route.path
    },
    // 当前高亮的index 【必须一致】
    defaultActive () {
      if (this.appletOwnedPathList.includes(this.currentPagePath) || (this.currentPagePath.indexOf(this.appletOwnedAddPath) !== -1)) {
        return 'owned'
      } else if (this.appletCheckPathList.includes(this.currentPagePath) || (this.currentPagePath.indexOf(this.appletCheckDetailsPath) !== -1)) {
        return 'check'
      } else if (this.topicsPathList.includes(this.currentPagePath) || (this.currentPagePath.indexOf(this.topicsAddPath) !== -1)) {
        return 'topics'
      } else if (this.swiperPathList.includes(this.currentPagePath)) {
        return 'swiper'
      } else {
        return ''
      }
    }
  },
  methods: {
    // 获取未审核数量
    getNotCheckCount () {
      api.getNotCheckCount().then(res => {
        if (res.data.code === 0) {
          console.log('未审核小程序数量', res.data.data)
          this.notCheckCount = res.data.data.sum
        } else {
          this.$message.error(res.data.message)
          console.log(res)
        }
      }).catch((error) => {
        console.log(error)
        this.$message.error(`网络错误，请检查网络设置`)
      })
    },
    // 菜单激活项
    routerSelect (index, indexPath) {
      // 进入小程序管理
      if (index === 'owned' || index === 'check') {
        this.$router.push(`/index/applet/${index}`)
      } else {
        this.$router.push(`/index/${index}`)
      }
    }
    // 传入当前页面路径 获取对应的indez

  }
}
</script>
<style lang="scss" scoped>
  .check {
    position: relative;
    .dot {
      position: absolute;
      top: 0;
      right: -40px;
      background-color: #F56C6C;
      border-radius: 10px;
      color: #fff;
      display: inline-block;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
      padding: 0 6px;
      text-align: center;
      white-space: nowrap;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/aside/aside-content.vue